import type { ReactElement } from 'react';
import { dataEl, type DataElScope } from '@/utils/dataEl';
import { CmarkdowntableCompactPreviewRow } from './CmarkdowntableCompactPreviewRow';
import type { CmarkdowntableCell } from './Cmarkdowntable.types';
import { extractTextFromNode } from './Cmarkdowntable.helpers';
const EMPTY_TABLE_ROW_VALUE = "emptyTableRow";
interface CmarkdowntableCompactPreviewProps {
    dataElScope: DataElScope;
    rows: CmarkdowntableCell[][];
}
export function CmarkdowntableCompactPreview({ dataElScope, rows, }: CmarkdowntableCompactPreviewProps): ReactElement | null {
    const previewRows = rows.slice(0, 3);
    if (previewRows.length === 0)
        return null;
    return (
      <div data-el={dataEl(dataElScope, 'CompactPreview/Root')} style={{ display: 'flex', flexDirection: 'column', height: '100%', gap: 4, padding: '0 0 26px', justifyContent: 'center' }}>
      {previewRows.map((row) => {
            const rowIdentity = getPreviewRowIdentity({ row });
            return (<CmarkdowntableCompactPreviewRow key={rowIdentity} row={row}/>);
        })}
      </div>
    );
}
function getPreviewRowIdentity(input: {
    row: CmarkdowntableCell[];
}): string {
    const rowText = input.row
        .map((cell) => extractTextFromNode(cell.content).trim())
        .filter(Boolean)
        .join('-');
    return rowText || EMPTY_TABLE_ROW_VALUE;
}
